var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGirl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "girl_black_24dp",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 12,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(2.437 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M12,6.625c.97,0,1.75-.585,1.75-1.312S12.97,4,12,4s-1.75.585-1.75,1.313S11.03,6.625,12,6.625ZM14,13v2.25c0,.412-.45.75-1,.75H11c-.55,0-1-.338-1-.75V13H9.44c-.7,0-1.18-.525-.94-1.013l1.88-3.773A1.791,1.791,0,0,1,12,7.375a1.791,1.791,0,0,1,1.62.84l1.88,3.772c.24.488-.24,1.013-.94,1.013Z",
    transform: "translate(-8.437 -4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.9d8b94164bb492dfbaecb9ef3d0bc00e.svg";
export { ForwardRef as ReactComponent };